var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9931 6.688C20.8895 6.15209 21.5602 5.30824 21.8801 4.314C21.0377 4.8138 20.1161 5.16588 19.1551 5.355C17.8226 3.94553 15.7116 3.60253 14.0015 4.51766C12.2913 5.43279 11.4056 7.37949 11.8391 9.27C8.38867 9.09677 5.17403 7.46692 2.99506 4.786C1.8579 6.74742 2.43902 9.25478 4.32306 10.516C3.64177 10.4941 2.97559 10.3096 2.38006 9.978C2.38006 9.996 2.38006 10.014 2.38006 10.032C2.38046 12.0752 3.82043 13.8351 5.82306 14.24C5.19113 14.4119 4.52827 14.4372 3.88506 14.314C4.44826 16.0613 6.05861 17.2583 7.89406 17.294C6.37389 18.4871 4.49654 19.1342 2.56406 19.131C2.22153 19.1315 1.87927 19.1118 1.53906 19.072C3.50145 20.333 5.78543 21.0024 8.11806 21C11.3633 21.0223 14.4821 19.7429 16.7768 17.448C19.0715 15.1531 20.3506 12.0342 20.3281 8.789C20.3281 8.603 20.3237 8.418 20.3151 8.234C21.1555 7.6266 21.8809 6.87415 22.4571 6.012C21.6741 6.35906 20.8435 6.58692 19.9931 6.688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.de3a96df173c8201b9e61960737428c5.svg";
export { ForwardRef as ReactComponent };